<template>
    <div class="inst-card-data">
        <CommonInstructions v-if="showCommonInstructions" :instructions="instructions"  :testData="testData" />
        <TestInstructions v-else :instructions="instructions" :testData="testData" />
    </div>
</template>

<script>
import CommonInstructions from "@/components/student/Tests/CommonInstructions.vue";
import TestInstructions from "@/components/student/Tests/TestInstructions.vue";

import { mapActions, mapState } from "vuex";

export default {
    name: "TestDashboard",
    mounted() {
        this.getTestInstructions();
    },
    components: {
        CommonInstructions,
        TestInstructions
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    data: () => ({
        showCommonInstructions: true,
        instructions: "",
        testData: null,
    }),
    methods: {
        ...mapActions({
            getInstructionsForTest: "testStore/getInstructions"
        }),
        getTestInstructions() {
            let isPreview = false;
            if (
                this.roleIds.CO === this.user.role_id ||
                this.roleIds.ID === this.user.role_id || 
				this.roleIds.ED === this.user.role_id ||
				this.roleIds.TR === this.user.role_id 
            ) {
                isPreview = true;
                this.showCommonInstructions = false
            }
            let reqData = {
                test_institute_id: this.$route.params.test_institute_id,
                schedule_id: this.$route.params.test_schedule_id,
                is_preview: isPreview
            };
            this.getInstructionsForTest(reqData)
                .then(resp => {
                    this.instructions = resp.instructions;
                    this.testData = resp;
                })
                .catch(e => {
                    const route = localStorage.getItem('previousRoute');
                    if(route=== "past-tests-teacher"|| route ==='assign-tests'){
                         this.$router.push({ name: route });
                    }else{
                           this.$router.push({ name:this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests" });
                    }
                    let errObj= ''
                    if (e && e.data && e.data.errors ) {
                        errObj=e.data.errors
                    }else if (e && e.data) {
                        errObj=e.data                        
                    }else{
                        errObj  = e
                    }

                    let error_log= new Error(`
                    **CHECK **LIVE ST::${this.user.id+""},
                    api:'check',
                    payload:${JSON.stringify(reqData)},
                    error:${JSON.stringify(errObj)},
                    networkStatus: ${navigator.onLine},
                    user_id: ${this.user.id}`)
                    localStorage.setItem('error_live_test',error_log)
                    this.sendLogData(errObj,'check','live-test-api',reqData)
                });
        },
        sendLogData(error, apiname,type,payload){
            let logData = {
            api: apiname,
            response:error,
            payload:payload,
            network_status: navigator.onLine,
            user_id:this.user.id,
            type
            }
            this.logData(logData).catch(err=>{
            let logdata = localStorage.getItem('logdata')
            if(logdata){
                logdata = JSON.parse(logdata)
            }else{
                logdata = [];
            }
            logdata.push(logData)
            localStorage.setItem('logdata',JSON.stringify(logdata))
            })
        },
    }
};
</script>
